import BeerSlider from 'beerslider';

export function initImageComparisonSliders() {
    const sliders = document.querySelectorAll('.beerslider');

    sliders.forEach(slider => {
        const beerSlider = new BeerSlider(slider);
        
        // Fix for iOS touch events on range input
        // iOS has a known issue where range inputs don't properly fire input/change events
        // during touch drag operations. This polyfill manually calculates position and
        // updates the slider when touch events occur.
        const rangeInput = slider.querySelector('.beer-range');
        
        if (rangeInput && 'ontouchstart' in window) {
            let isTouching = false;
            
            const updateSliderFromTouch = (touch) => {
                const rect = rangeInput.getBoundingClientRect();
                const percentage = ((touch.clientX - rect.left) / rect.width) * 100;
                const clampedValue = Math.min(100, Math.max(0, percentage));
                
                rangeInput.value = clampedValue;
                rangeInput.setAttribute('aria-valuenow', clampedValue);
                
                // Trigger the change manually for BeerSlider to update visuals
                const inputEvent = new Event('input', { bubbles: true });
                rangeInput.dispatchEvent(inputEvent);
            };
            
            rangeInput.addEventListener('touchstart', (e) => {
                isTouching = true;
                updateSliderFromTouch(e.touches[0]);
            }, { passive: true });
            
            rangeInput.addEventListener('touchmove', (e) => {
                if (isTouching) {
                    updateSliderFromTouch(e.touches[0]);
                    // Only prevent default during move to avoid blocking click/tap
                    e.preventDefault();
                }
            }, { passive: false });
            
            rangeInput.addEventListener('touchend', () => {
                isTouching = false;
            }, { passive: true });
            
            rangeInput.addEventListener('touchcancel', () => {
                isTouching = false;
            }, { passive: true });
        }
    });
}